import { useIntl } from "gatsby-plugin-intl";

export function useMetaTitle(title: string): string {
  const intl = useIntl();
  return `${title} - ${intl.formatMessage({ id: "league-of-legends.title" })}`;
}
